var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountsInfoContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4635 12.083H13.5469C11.7371 12.083 11.3594 12.4607 11.3594 14.2705V22.2913H18.651V14.2705C18.651 12.4607 18.2733 12.083 16.4635 12.083Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2734 15L15.7318 15M14.2734 17.1875H15.7318M14.2734 19.375H15.7318",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5677 22.2913V12.2184C21.5677 11.3227 21.5677 10.8749 21.3499 10.5151C21.1321 10.1552 20.7399 9.95491 19.9554 9.55437L16.7896 7.93796C15.9435 7.50591 15.7344 7.65818 15.7344 8.60396V11.8668",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 22.2917V15.7292C8.4375 15.1259 8.5634 15 9.16667 15H11.3542",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2943 22.292H7.71094",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsInfoContainer);
export default __webpack_public_path__ + "static/media/AccountsInfoContainer.bfd1cdc8a4da1a81dac72608f1890068.svg";
export { ForwardRef as ReactComponent };